/**
 * viewportSource: the viewport the keyboard and viewport hooks read beside the browser's own
 * (shared-client-screens D2). Inside Telegram the web view's height lags the keyboard, so the
 * Mini App's root provides Telegram's viewport (`telegramViewport` in utils/telegram.ts); the
 * studio website provides none and the hooks read the browser alone. The hooks themselves
 * never touch Telegram, so a shared screen can run them on both sides.
 */
import { createContext, useContext } from 'react';

/** The slice of Telegram's WebApp the hooks read. */
export interface ViewportSource {
  readonly viewportHeight: number;
  readonly viewportStableHeight: number;
  onEvent(eventType: 'viewportChanged', callback: (event?: unknown) => void): void;
  offEvent(eventType: 'viewportChanged', callback: (event?: unknown) => void): void;
}

/** Read at effect and event time, as the hooks always read Telegram's viewport. */
export type ViewportSourceGetter = () => ViewportSource | undefined;

const browserOnly: ViewportSourceGetter = () => undefined;

export const ViewportSourceContext = createContext<ViewportSourceGetter>(browserOnly);

export function useViewportSource(): ViewportSourceGetter {
  return useContext(ViewportSourceContext);
}
